module.exports = __webpack_public_path__ + "media/use-form/conferences-summits@2x-34f4c105.png";